<template>
  <div class="unauthorized-block">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "UnauthorizedBlock"
}
</script>

<style scoped lang="scss">
.unauthorized-block {
  @apply bg-block mx-auto shadow-primaryBlock rounded mt-3;
  width: 40rem;
  padding: 5.3rem 5rem 3.9rem;
  @media(max-width: 767.98px){
    width: calc(100% - 15px);
    padding: 2rem 1.5rem 2rem;
  }
}
</style>